import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", { class: "pi pi-cog" }, null, -1);
const _hoisted_2 = [
    _hoisted_1
];
import Sidebar from 'primevue/sidebar';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppConfigSideBar',
    props: /*#__PURE__*/ _mergeModels({
        simple: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "Configuration"
        },
        active: {
            type: Boolean,
            default: false
        }
    }, {
        "modelValue": { type: Boolean },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const model = _useModel(__props, "modelValue");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("button", {
                    class: _normalizeClass(["layout-config-button p-link", __props.active ? 'layout-config-button-active' : '']),
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event) => (model.value = true))
                }, _hoisted_2, 2),
                _createVNode(_unref(Sidebar), {
                    visible: model.value,
                    "onUpdate:visible": _cache[1] || (_cache[1] = ($event) => ((model).value = $event)),
                    position: "right",
                    transitionOptions: '.3s cubic-bezier(0, 0, 0.2, 1)',
                    class: "layout-config-sidebar w-24rem"
                }, {
                    header: _withCtx(() => [
                        _createElementVNode("h5", null, _toDisplayString(__props.title), 1)
                    ]),
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                }, 8, ["visible", "transitionOptions"])
            ], 64));
        };
    }
});
